// extracted by mini-css-extract-plugin
export default {"popup":"SideMenu_popup__pr-l2","closeBtn":"SideMenu_closeBtn__yNBgG"};